export enum HorizontalAlignment {
    left = 'left',
    center = 'center',
    right = 'right',
}
